import { dumbledoreMediaArray } from './dumbledoreMedia'
import { dumbledoreBio } from './dumbledoreBios'

import { hermioneReviewerReviewHinge, ronReviewerReviewBumble, harryReviewerReviewTinder } from './dumbledoreReviewerReviews'
import { hermioneReviewerProfile, ronReviewerProfile, harryReviewerProfile } from './dumbledoreReviewers'

export const hermioneProfileReviewHinge = {
  _id: 'hermioneProfileReviewHingeId',
  userId: 'dumbledoreUserId',
  userEmail: 'dumbledore@email.com',
  datingProfileId: 'dumbledoreDatingProfileHingeId',
  reviewerProfileId: 'hermioneReviewerProfileId',
  reviewerEmail: 'hermione@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: dumbledoreMediaArray[0]._id,
      mediaItemURL: dumbledoreMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[0].type,
      caption: dumbledoreMediaArray[0].captions[0],
      subcaption: dumbledoreMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: dumbledoreMediaArray[4]._id,
      mediaItemURL: dumbledoreMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[4].type,
      caption: dumbledoreMediaArray[4].captions[2],
      subcaption: dumbledoreMediaArray[4].subcaptions[1],
    },
    {
      mediaItemId: dumbledoreMediaArray[7]._id,
      mediaItemURL: dumbledoreMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[7].type,
      caption: dumbledoreMediaArray[7].captions[1],
      subcaption: dumbledoreMediaArray[7].subcaptions[1],
    },
    {
      mediaItemId: dumbledoreMediaArray[8]._id,
      mediaItemURL: dumbledoreMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[8].type,
      caption: dumbledoreMediaArray[8].captions[0],
      subcaption: dumbledoreMediaArray[8].subcaptions[0],
    },
    {
      mediaItemId: dumbledoreMediaArray[1]._id,
      mediaItemURL: dumbledoreMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[1].type,
      caption: dumbledoreMediaArray[1].captions[0],
      subcaption: dumbledoreMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: dumbledoreMediaArray[6]._id,
      mediaItemURL: dumbledoreMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[6].type,
      caption: dumbledoreMediaArray[6].captions[2],
      subcaption: dumbledoreMediaArray[6].subcaptions[2],
    }
  ],
  mediaFeedback: [
    {
      feedback: `Wow you look like a wizard fatale here. Great start! Looking hot!`,
      verdict: 'Very',
    },
    {
      feedback: `Love the aesthetic! Looking very classy, even Godlike! You're a total catch!`,
      verdict: 'Yes',
    },
    {
      feedback: `Another one where you look wise, but maybe you're too serious overall. Perhaps think about adding something more lighthearted.`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Funny caption! You really do look like Gandalf here!`,
      verdict: 'Yes',
    },
    {
      feedback: `Another funny caption. Cool beard ties`,
      verdict: 'Yes',
    },
    {
      feedback: `Nice action shot but maybe too intense. The caption is great though`,
      verdict: 'Yes',
    }
  ],
  bio: {
    bioItemsId: dumbledoreBio._id,
    vitalInfo: { ...dumbledoreBio.vitalInfo },
    prompts: [
      { ...dumbledoreBio.prompts[0] },
      { ...dumbledoreBio.prompts[1] },
      { ...dumbledoreBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: [],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `You are extraordinarily accomplished, but perhaps a bit old`,
      verdict: 'Yes', 
    },
    aboutMeFeedback: {
      feedback: '',
      verdict: '', 
    },
    promptsFeedback: [
      {
        feedback: `The beard jokes are all funny to me, but maybe add more variety to your humor overall`,
        verdict: 'Yes', 
      },
      {
        feedback: `Funny! Love the self-deprecation!`,
        verdict: 'Very', 
      },
      {
        feedback: `A bit bland`,
        verdict: 'No', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Albus is very well-groomed, accomplished, and witty.`,
    good: `You're obviously super accomplished, and you present yourself as witty too`,
    notGood: `The intensity. Try a few more pictures where you're smiling.`,
    verdict: `Overall the positives outweigh the negatives, and I think you're close to showing your most attractive self. Adding a few more candid photos could really take your profile to the next level`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...hermioneReviewerReviewHinge },
  reviewerProfile: { ...hermioneReviewerProfile },
  bioItems: { ...dumbledoreBio },
  mediaItems: [ ...dumbledoreMediaArray ],
}

export const ronProfileReviewBumble = {
  _id: 'ronProfileReviewBumbleId',
  userId: 'dumbledoreUserId',
  userEmail: 'dumbledore@email.com',
  datingProfileId: 'dumbledoreDatingProfileBumbleId',
  reviewerProfileId: 'dumbledoreReviewerProfileId',
  reviewerEmail: 'dumbledore@email.com',
  isAIReview: true,
  isFriendReview: false,
  nameOfLLM: 'ChatGPT + Gemini',
  modelOfLLM: 'GPT-4o mini + gemini-1.5-flash-8b',
  priceOfReview: 10,
  reviewSubmitted: true,
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: dumbledoreMediaArray[0]._id,
      mediaItemURL: dumbledoreMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[0].type,
      caption: dumbledoreMediaArray[0].captions[0],
      subcaption: dumbledoreMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: dumbledoreMediaArray[4]._id,
      mediaItemURL: dumbledoreMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[4].type,
      caption: dumbledoreMediaArray[4].captions[2],
      subcaption: dumbledoreMediaArray[4].subcaptions[1],
    },
    {
      mediaItemId: dumbledoreMediaArray[7]._id,
      mediaItemURL: dumbledoreMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[7].type,
      caption: dumbledoreMediaArray[7].captions[1],
      subcaption: dumbledoreMediaArray[7].subcaptions[1],
    },
    {
      mediaItemId: dumbledoreMediaArray[8]._id,
      mediaItemURL: dumbledoreMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[8].type,
      caption: dumbledoreMediaArray[8].captions[0],
      subcaption: dumbledoreMediaArray[8].subcaptions[0],
    },
    {
      mediaItemId: dumbledoreMediaArray[1]._id,
      mediaItemURL: dumbledoreMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[1].type,
      caption: dumbledoreMediaArray[1].captions[0],
      subcaption: dumbledoreMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: dumbledoreMediaArray[6]._id,
      mediaItemURL: dumbledoreMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[6].type,
      caption: dumbledoreMediaArray[6].captions[2],
      subcaption: dumbledoreMediaArray[6].subcaptions[2],
    }
  ],
  mediaFeedback: [
    {
      feedback: `Wow you look like a wizard fatale here. Great start! Looking hot!`,
      verdict: 'Very',
    },
    {
      feedback: `Love the aesthetic! Looking very classy, even Godlike! You're a total catch!`,
      verdict: 'Yes',
    },
    {
      feedback: `Another one where you look wise, but maybe you're too serious overall. Perhaps think about adding something more lighthearted.`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Funny caption! You really do look like Gandalf here!`,
      verdict: 'Yes',
    },
    {
      feedback: `Another funny caption. Cool beard ties`,
      verdict: 'Yes',
    },
    {
      feedback: `Nice action shot but maybe too intense. The caption is great though`,
      verdict: 'Yes',
    }
  ],
  bio: {
    bioItemsId: dumbledoreBio._id,
    vitalInfo: { ...dumbledoreBio.vitalInfo },
    prompts: [
      { ...dumbledoreBio.prompts[0] },
      { ...dumbledoreBio.prompts[1] },
      { ...dumbledoreBio.prompts[2] }
    ],
    aboutMe: dumbledoreBio.aboutMe[0],
    hobbies: [dumbledoreBio.hobbies[0], dumbledoreBio.hobbies[1], dumbledoreBio.hobbies[2], dumbledoreBio.hobbies[3], dumbledoreBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `You are extraordinarily accomplished, but perhaps a bit old`,
      verdict: 'Yes', 
    },
    aboutMeFeedback: {
      feedback: `Love the joke! You're witty!`,
      verdict: 'Very', 
    },
    promptsFeedback: [
      {
        feedback: `The beard jokes are all funny to me, but maybe add more variety to your humor overall`,
        verdict: 'Yes', 
      },
      {
        feedback: `Funny! Love the self-deprecation!`,
        verdict: 'Very', 
      },
      {
        feedback: `A bit bland`,
        verdict: 'No', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Albus is very well-groomed, accomplished, and witty.`,
    good: `You're obviously super accomplished, and you present yourself as witty too`,
    notGood: `The intensity. Try a few more pictures where you're smiling.`,
    verdict: `Overall the positives outweigh the negatives, and I think you're close to showing your most attractive self. Adding a few more candid photos could really take your profile to the next level`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...ronReviewerReviewBumble },
  reviewerProfile: { ...ronReviewerProfile },
  bioItems: { ...dumbledoreBio },
  mediaItems: [ ...dumbledoreMediaArray ],
}

export const harryProfileReviewTinder = {
  _id: 'harryProfileReviewTinderId',
  userId: 'dumbledoreUserId',
  userEmail: 'dumbledore@email.com',
  datingProfileId: 'dumbledoreDatingProfileTinderId',
  reviewerProfileId: 'harryReviewerProfileId',
  reviewerEmail: 'harry@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: dumbledoreMediaArray[0]._id,
      mediaItemURL: dumbledoreMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[0].type,
      caption: dumbledoreMediaArray[0].captions[0],
      subcaption: dumbledoreMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: dumbledoreMediaArray[4]._id,
      mediaItemURL: dumbledoreMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[4].type,
      caption: dumbledoreMediaArray[4].captions[2],
      subcaption: dumbledoreMediaArray[4].subcaptions[1],
    },
    {
      mediaItemId: dumbledoreMediaArray[7]._id,
      mediaItemURL: dumbledoreMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[7].type,
      caption: dumbledoreMediaArray[7].captions[1],
      subcaption: dumbledoreMediaArray[7].subcaptions[1],
    },
    {
      mediaItemId: dumbledoreMediaArray[8]._id,
      mediaItemURL: dumbledoreMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[8].type,
      caption: dumbledoreMediaArray[8].captions[0],
      subcaption: dumbledoreMediaArray[8].subcaptions[0],
    },
    {
      mediaItemId: dumbledoreMediaArray[1]._id,
      mediaItemURL: dumbledoreMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[1].type,
      caption: dumbledoreMediaArray[1].captions[0],
      subcaption: dumbledoreMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: dumbledoreMediaArray[6]._id,
      mediaItemURL: dumbledoreMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[6].type,
      caption: dumbledoreMediaArray[6].captions[2],
      subcaption: dumbledoreMediaArray[6].subcaptions[2],
    }
  ],
  mediaFeedback: [
    {
      feedback: `Wow you look like a wizard fatale here. Great start! Looking hot!`,
      verdict: 'Very',
    },
    {
      feedback: `Love the aesthetic! Looking very classy, even Godlike! You're a total catch!`,
      verdict: 'Yes',
    },
    {
      feedback: `Another one where you look wise, but maybe you're too serious overall. Perhaps think about adding something more lighthearted.`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Funny caption! You really do look like Gandalf here!`,
      verdict: 'Yes',
    },
    {
      feedback: `Another funny caption. Cool beard ties`,
      verdict: 'Yes',
    },
    {
      feedback: `Nice action shot but maybe too intense. The caption is great though`,
      verdict: 'Yes',
    }
  ],
  bio: {
    bioItemsId: dumbledoreBio._id,
    vitalInfo: { ...dumbledoreBio.vitalInfo },
    prompts: [
      { ...dumbledoreBio.prompts[0] },
      { ...dumbledoreBio.prompts[1] },
      { ...dumbledoreBio.prompts[2] }
    ],
    aboutMe: dumbledoreBio.aboutMe[0],
    hobbies: [dumbledoreBio.hobbies[0], dumbledoreBio.hobbies[1], dumbledoreBio.hobbies[2], dumbledoreBio.hobbies[3], dumbledoreBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `You are extraordinarily accomplished, but perhaps a bit old`,
      verdict: 'Yes', 
    },
    aboutMeFeedback: {
      feedback: `Love the joke! You're witty!`,
      verdict: 'Very', 
    },
    promptsFeedback: [
      {
        feedback: `The beard jokes are all funny to me, but maybe add more variety to your humor overall`,
        verdict: 'Yes', 
      },
      {
        feedback: `Funny! Love the self-deprecation!`,
        verdict: 'Very', 
      },
      {
        feedback: `A bit bland`,
        verdict: 'No', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Albus is very well-groomed, accomplished, and witty.`,
    good: `You're obviously super accomplished, and you present yourself as witty too`,
    notGood: `The intensity. Try a few more pictures where you're smiling.`,
    verdict: `Overall the positives outweigh the negatives, and I think you're close to showing your most attractive self. Adding a few more candid photos could really take your profile to the next level`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...harryReviewerReviewTinder },
  reviewerProfile: { ...harryReviewerProfile },
  bioItems: { ...dumbledoreBio },
  mediaItems: [ ...dumbledoreMediaArray ],
}